import { useContext } from 'react';

import { TimeseriesRawDataContext } from '../context/TimeseriesRawData.context.js';

export const useTimeseriesRawData = () => useContext(TimeseriesRawDataContext);
